export default __webpack_public_path__ + "static/media/Manage_roles_white.3265b1c4.svg";